<template>
  <div class="hiq-article-list__filter-remover hiq-search-filter__remover">
    <button
      v-if="selectedFilters.length > 0"
      @click="clearFilters"
      class="hiq-article-list__filter-remover-all hiq-search-filter__remover-all">
        Rensa alla filter
    </button>
    <button
      v-for="(filter, index) in selectedFilters"
      @click="deselectFilter(filter.name, filter.option)"
      :key="'selected-filter' + index"
      class="hiq-article-list__filter-remover-single hiq-search-filter__remover-single">
        {{ filter.option.title }}
        <span class="show-for-sr"> , Ta bort filterval</span>
    </button>
  </div>
</template>
    
<script lang="ts">
import Vue from "vue";
import { ITagOption, ISelectedFilter } from "../store/state";
import { search } from "../store/actions";

interface ArticleFilterRemoverComputed {
  selectedFilters: ISelectedFilter[];
}
interface ArticleFilterRemoverMethods {
  getSelectedOptions(options: ITagOption[], option: ITagOption): ITagOption[];

  updateSelectedFilters(setFilter: string,selectedOptions: ITagOption[]): void;

  clearFilters(): void;

  deselectFilter(fName: string, option: ITagOption): void;
}
export default Vue.extend<{},ArticleFilterRemoverMethods,ArticleFilterRemoverComputed,{}>({
  name: "ArticleFilterRemover",
  computed: {
    selectedFilters() {
      return this.$store.getters.selectedFilters;
    },
  },

  methods: {
    getSelectedOptions(items: ITagOption[], option: ITagOption) {
      return items.filter(
        (item: ITagOption) => item.name !== option.name && item.selected
      );
    },

    updateSelectedFilters(setFilter: string, selectedOptions: ITagOption[]) {
      let selectedOptionsStr = selectedOptions
        .map((option: ITagOption) => {
            if(option.name && option.name != '') return option.name
          })
        .join(",");

      this.$store.commit({
        type: setFilter,
        payload: selectedOptionsStr,
      });
    },

    clearFilters() {
      this.$store.commit({
        type: "setClearFilters",
        payload: '',
      });
      this.$store.commit({
        type: "setOperations",
        payload: '',
      });
      // this.$store.commit({
      //   type: "setProfessions",
      //   payload: '',
      // });
      this.$store.commit({
        type: "setThemes",
        payload: '',
      });
      this.$store.commit({
        type: "setSubjects",
        payload: '',
      });

      this.$store.commit({
        type: "setBlogNames",
        payload: '',
      });

      this.$store.commit({
        type: "setDates",
        payload: {
          start: '',
          end: ''
        }
      });

      this.$store.dispatch(search(""));
    },

    deselectFilter(fName: string, option: ITagOption) {
      switch (fName) {
        case "Verksamhet":
          let operations = this.$store.getters.operations;
          let selectedOperations = this.getSelectedOptions(operations, option);
          this.updateSelectedFilters(
            "setOperations",
            selectedOperations
          );
          break;

        // case "Yrkeskategori":
        //   let professions = this.$store.getters.professions;
        //   let selectedProfessions = this.getSelectedOptions(
        //     professions,
        //     option
        //   );
        //   this.updateSelectedFilters(
        //     "setProfessions",
        //     selectedProfessions
        //   );
        //   break;

        case "Ämne":
          let subjects = this.$store.getters.subjects;
          let selectedSubjects = this.getSelectedOptions(subjects, option);
          this.updateSelectedFilters(
            "setSubjects",
            selectedSubjects
          );
          break;

        case "Tema":
          let themes = this.$store.getters.themes;
          let selectedThemes = this.getSelectedOptions(themes, option);
          this.updateSelectedFilters(
            "setThemes",
            selectedThemes
          );
          break;

        case "Bloggnamn":
          let blogNames = this.$store.getters.blogNames;
          let selectedBlogNames = this.getSelectedOptions(blogNames, option);
          this.updateSelectedFilters(
            "setBlogNames",
            selectedBlogNames
          );
          break;

        case "dates":
          this.$store.commit({
          type: "setDates",
          payload: {
              start: '',
              end: ''
            }
          });
          break;
      }

      this.$store.dispatch(search(""));
    },
  },
});
</script>